"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _immutable = require("immutable");
var _StateHelper = _interopRequireDefault(require("../../helpers/StateHelper.js"));
var _CmeActivityTracker = _interopRequireDefault(require("../../factories/CmeActivityTracker.js"));
var _constants = require("../../constants");
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}
var stateHelper = new _StateHelper.default(_CmeActivityTracker.default);
var reducers = {};

// V1 CME
reducers[_constants.CME_TRACKER_FETCHED] = stateHelper.set;

// V2 CME (Tutor Mode Enabled)
reducers[_constants.CME_ACTIVITIES_FETCHED] = function cmeActivitiesFetched(state, payload) {
  var newState = state;
  payload.data.forEach(function (json) {
    var activityId = parseInt(json.id);
    newState = newState.set(activityId, new _immutable.Map({
      cme_activity_id: activityId,
      user_id: payload.userId,
      cme_credit_tracker_id: null,
      question_bank_id: null,
      credits_earned: 0,
      earliest_available_cme: '',
      eligible_to_redeem_hours: null,
      incorrect_total: 0,
      latest_available_cme: '',
      meets_minimum_percent_correct: null,
      percent_correct: '',
      questions_total_to_next_credit: 0
    }));
  });
  return newState;
};
reducers[_constants.CME_CALCULATED] = function cmeCalculated(state, payload) {
  var newState = state;
  Object.keys(payload.cmeActivityStats).forEach(function (cmeActivityIdString) {
    var cmeActivityId = parseInt(cmeActivityIdString);
    var stats = payload.cmeActivityStats[cmeActivityId];
    newState = newState.mergeIn([cmeActivityId], {
      credits_earned: Math.round(stats.creditsEarned),
      incorrect_total: stats.incorrectCount,
      percent_correct: stats.percentCorrect,
      questions_total_to_next_credit: stats.questionsTotalToNextCredit,
      questions_for_credit: stats.questionsForCredit,
      questions_per_hour: stats.questionsPerHour,
      earliest_available_cme: stats.earliestAvailableCme,
      latest_available_cme: stats.latestAvailableCme
    });
  });
  return newState;
};
reducers[_constants.SESSION_RESET] = stateHelper.reset;
var _default = exports.default = stateHelper.createReducer(reducers);